import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ZoningCodeService } from 'src/app/core/services/zoning-code.service';
import { CalibrationSetType } from 'src/shared/enums/calibration-set-type';
import { ICloneUsesPopupProperties } from 'src/shared/zoneiqui/interfaces/clone-uses-popup-properties.interface';
import * as _ from 'lodash';

import ICalibrationSet = ZoneIQCalibration.ICalibrationSet;
import { ICalibrationSetModel } from 'src/app/interfaces/calibration-set-model.interface';
import { OverlayModel, ZoneCombinationModel } from 'src/app/models';

@Component({
    standalone: false,
    selector: 'app-clone-uses-popup',
    templateUrl: './clone-uses-popup.component.html',
    styleUrls: ['./clone-uses-popup.component.scss']

})
export class CloneUsesPopupComponent implements OnInit {

    destinations = new UntypedFormControl();
    calibrationSets: ICalibrationSetModel<ICalibrationSet>[];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ICloneUsesPopupProperties,
        private readonly zoningCodeService: ZoningCodeService,
        public dialogRef: MatDialogRef<CloneUsesPopupComponent>,
    ) {
        // This check is needed because Zoning Code Overlays also contains Typologies. That should be changed.
        const collectionType = this.calibrationSetType === CalibrationSetType.ZONE_COMBINATION
            ? CalibrationSetType.ZONE_COMBINATION
            : CalibrationSetType.OVERLAY;
        this.calibrationSets = this.zoningCodeService
            .selectedZoningCode
            .getCalibrationSetCollection(collectionType)
            .filter(calibrationSet => calibrationSet.Id !== this.data.calibrationSet.Id)
            .sort(this.calibrationSetType === CalibrationSetType.ZONE_COMBINATION ? ZoneCombinationModel.sortingCalibrationByName : OverlayModel.sortingCalibrationByName);
    }

    get canClone() {
        return !!_.get(this, 'destinations.value.length', 0);
    }

    get calibrationSetType() {
        return _.get(this, 'data.calibrationSetType');
    }

    get calibrationSetCombinedTypeStr() {
        switch (this.calibrationSetType) {
            case CalibrationSetType.ZONE_COMBINATION:
                return 'Zone';
            case CalibrationSetType.OVERLAY:
            case CalibrationSetType.TYPOLOGY:
                return 'Overlay\\Typology';
        }
    }

    ngOnInit() {
    }

    cloneUses() {
        // console.log(this.destinations.value);
        if (!this.canClone) {
            return;
        }

        const calibrationSetsIds = this.destinations.value as number[];
        calibrationSetsIds.forEach(calibrationSetId => {
            const calibrationSet = this.calibrationSets.find(calibrationSet => calibrationSet.Id === calibrationSetId);
            if (!calibrationSet) {
                return;
            }
            calibrationSet.cloneCalibrationUsesValues(this.data.calibrationSet.CalibrationUsesVals);
        });

        this.dialogRef.close();
    }
}
